import Cache from '@panda/cache/src/shared/cache';
import { NosToken } from '@panda/cache/src/shared/define/Share';
import { MD5 } from 'crypto-js';
import NosUploader from '../lib/NosUploader';
import { UploadResult } from '../defines/upload';

const cache = new Cache();

const K_BYTE = 1024;
const M_BYTE = 1024 * K_BYTE;
const TRUNK_SIZE = 4;

/**
 * @param file 待上传的文件
 * @param ext 文件扩展名
 */
function uploadFileToSteam(file: File, ext: string, onProgress?: Function, client = 'admin'): Promise<UploadResult> {
  return new Promise((resolve, reject) => {
    const uploader = NosUploader({
      onError: (err: string) => {
        console.log(err);
        reject(new Error('文件上传失败！请重试'));
      },
      onProgress: (curFile: any) => {
        if (onProgress) {
          onProgress(curFile);
        }
      },
    });
    uploader.addFile(file, async () => {
      // TODO: 获取nosToken 必须上传content-type
      try {
        let res: NosToken[];
        if (client === 'web') {
          const date = new Date().getTime();
          res = await cache.getNosTokenSafe({
            data: {
              ext: `.${ext}`,
              m: String(date),
            },
            headers: {
              a: MD5(`t65a88640a5d88e7c84708${date}`).toString(),
            },
          });
        } else {
          res = await cache.getNosToken({
            data: {
              num: 1,
              ext: `.${ext}`,
            },
          });
        }
        const tokenObj: NosToken = res[0] || {};
        const { objectName, token, bucket } = tokenObj;

        const param = {
          bucketName: bucket,
          objectName,
          token,
          trunkSize: TRUNK_SIZE * M_BYTE,
        };
        uploader.upload(param, () => {
          resolve({
            bucketName: bucket,
            nosKey: objectName,
            url: `https://${bucket}.nosdn.127.net/${encodeURIComponent(objectName)}`,
          });
        });
      } catch (err) {
        console.log(err);
        reject(new Error('获取token失败！请重新上传'));
      }
    });
  });
}

export default uploadFileToSteam;
